import { trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { CHANNELS } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';
import { formatScheduleRanges } from '@spotahome/ui-library/src/tenant/components/PropertyRulesRedesign/utils';

const renderScheduleSection = (dateSections) =>
  dateSections
    .filter(s => s.content && s.content.length > 0)
    .map(s => (
      <div className="arrival-keys-simplified-modal__schedule-item" key={s.title}>
        <span className="arrival-keys-simplified-modal__schedule-title">
          {s.title}
        </span>
        <span className="arrival-keys-simplified-modal__schedule-content">
          {s.content}
        </span>
      </div>
    ));

const openArrivalKeysSimplifiedModal = ({
  moveInMoveOutPolicy,
  hasSchedules,
  hasAfterHours,
  fullscreenOnMobile = false
} = {}) => {
  const { moveIn, moveOut } = hasSchedules
    ? formatScheduleRanges(moveInMoveOutPolicy.moveInMoveOutSchedules?.ranges)
    : { moveIn: [], moveOut: [], tip: null };

  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.simplification.bottom.arrival-keys.card.title'),
    body: (
      <>
        <p className="arrival-keys-simplified-modal__intro">
          {trans('listing.simplification.bottom.arrival-keys.modal.intro')}
        </p>

        {hasSchedules && (
          <>
            <div className="arrival-keys-simplified-modal__section">
              <div className="arrival-keys-simplified-modal__section-header">
                <DSIcon name="clock" size="l" />
                <h3 className="arrival-keys-simplified-modal__section-title">
                  {trans(
                    'listing.simplification.bottom.arrival-keys.move-in-out-hours.chip'
                  )}
                </h3>
              </div>
              {renderScheduleSection([
                {
                  title: trans('property.rule.moveInMoveOut.checkIn'),
                  content: moveIn.map(range => <span key={range}>{range}</span>)
                },
                {
                  title: trans('property.rule.moveInMoveOut.checkOut'),
                  content: moveOut.map(range => <span key={range}>{range}</span>)
                }
              ])}
            </div>
            <hr className="arrival-keys-simplified-modal__divider" />
          </>
        )}

        {hasAfterHours && (
          <>
            <div className="arrival-keys-simplified-modal__section">
              <div className="arrival-keys-simplified-modal__section-header">
                <DSIcon name="calendar_month" size="l" />
                <h3 className="arrival-keys-simplified-modal__section-title">
                  {trans(
                    'listing.simplification.bottom.arrival-keys.after-hours.chip'
                  )}
                </h3>
              </div>
              <p className="arrival-keys-simplified-modal__section-body">
                {trans(
                  'listing.simplification.bottom.arrival-keys.after-hours.modal.body'
                )}
              </p>
            </div>
            <hr className="arrival-keys-simplified-modal__divider" />
          </>
        )}

        <div className="arrival-keys-simplified-modal__section">
          <div className="arrival-keys-simplified-modal__section-header">
            <DSIcon name="key_down" size="l" />
            <h3 className="arrival-keys-simplified-modal__section-title">
              {trans(
                'listing.simplification.bottom.arrival-keys.key-handover.chip'
              )}
            </h3>
          </div>
          <p className="arrival-keys-simplified-modal__section-body">
            {trans(
              'listing.simplification.bottom.arrival-keys.key-handover.modal.body'
            )}
          </p>
        </div>
        <hr className="arrival-keys-simplified-modal__divider" />
      </>
    ),
    fullscreenOnMobile
  });
};

export default openArrivalKeysSimplifiedModal;
